import { useQuery } from '@tanstack/react-query'
import { api } from '../client'
import { chaves } from './chaves'
import type {
  ItemDeReferencia,
  ModuloDeReferencia,
  PessoaDeReferencia,
  StatusDeReferencia,
} from '../../types/gmud'

/**
 * Listas de apoio dos campos de escolha.
 *
 * Sistemas e finalidades são tabela no banco, não enum: cadastrar um tipo de manutenção
 * novo é INSERT, não deploy. Por isso a tela busca em vez de trazer uma constante — e
 * por isso o cache é longo, já que a lista muda uma vez por ano.
 */
const UMA_HORA = 60 * 60 * 1000

export function useSistemas() {
  return useQuery({
    queryKey: chaves.referencias('sistemas'),
    queryFn: async () => (await api.get<ItemDeReferencia[]>('/referencias/sistemas')).data,
    staleTime: UMA_HORA,
  })
}

/**
 * Os módulos do e-Cidade e os sub-módulos de cada um.
 *
 * Vem tudo de uma vez — 8 módulos e 47 pares — porque o segundo select filtra o primeiro em
 * memória. Buscar os sub-módulos a cada troca de módulo daria uma espera visível num formulário
 * cujo público é leigo, para economizar 47 linhas.
 */
export function useModulos() {
  return useQuery({
    queryKey: chaves.referencias('modulos'),
    queryFn: async () => (await api.get<ModuloDeReferencia[]>('/referencias/modulos')).data,
    staleTime: UMA_HORA,
  })
}

/** As contas ativas, para o campo de responsável pela execução. */
export function usePessoas() {
  return useQuery({
    queryKey: chaves.referencias('pessoas'),
    queryFn: async () => (await api.get<PessoaDeReferencia[]>('/referencias/pessoas')).data,
    staleTime: UMA_HORA,
  })
}

export function useFinalidades() {
  return useQuery({
    queryKey: chaves.referencias('finalidades'),
    queryFn: async () => (await api.get<ItemDeReferencia[]>('/referencias/finalidades')).data,
    staleTime: UMA_HORA,
  })
}

/**
 * Os estados possíveis, na ordem do processo do ANEXO XXI.
 *
 * O filtro de status usa esta lista, e não as chaves de `ROTULO_STATUS`: assim um estado
 * novo no domínio aparece no filtro sem deploy do frontend, e o glossário continua sendo
 * só a tradução. O teste do glossário garante que os dois conjuntos não divirjam.
 */
export function useStatusDeReferencia() {
  return useQuery({
    queryKey: chaves.referencias('status'),
    queryFn: async () => (await api.get<StatusDeReferencia[]>('/referencias/status')).data,
    staleTime: UMA_HORA,
  })
}
